export default __webpack_public_path__ + "static/media/workspace_board.7e404967.png";